import React, {createContext, useMemo, useState} from "react";
import {useDeals} from "./useDeals";
import {useNotify} from "../../domains/common/components/AlertNotify";
import {Grid2 as Grid, useTheme} from "@mui/material";
import Box from "@mui/material/Box";
import {DealsHeader} from "./components/header";

import {DealsList} from "./components/list";
import EventsDrawer from "../deal/components/DealEvents";
import {DealsFilter} from "./components/filter";

export const DealsPageContext = createContext();

export const DealsProvider = ({children}) => {
  const [loading, setLoading] = useState(true);
  const {
    dealsList,
    loadDealsData,
    setDealsList,
    loadNextDeals,
    loadPrevDeals,
    dealsNum,
    loadListDataWStateFilter,
    currentListOffset,
    setDisablePagination,
    pinDeal,
    unpinDeal,
    resetOffset
  } = useDeals();

  const {eventsDrawerComponent, openEventsDrawer} = EventsDrawer({closeOnBackdrop: true})

  const {openNotify} = useNotify();

  const value = useMemo(() => ({
    loadDealsData,
    loading,
    dealsList,
    setDealsList,
    loadNextDeals,
    openEventsDrawer,
    loadPrevDeals,
    dealsNum,
    currentListOffset,
    loadListDataWStateFilter,
    setDisablePagination,
    openNotify,
    pinDeal,
    unpinDeal,
    resetOffset
  }), [loadDealsData, loading, dealsList, setDealsList, loadNextDeals, loadPrevDeals, openEventsDrawer, dealsNum, pinDeal]);

  return (
    <DealsPageContext.Provider value={value}>
      {eventsDrawerComponent}
      {children}
    </DealsPageContext.Provider>
  );
};

export default function DealListPage() {
  const theme = useTheme();

  return (
    <DealsProvider>
      <Box sx={{
        position: 'fixed',
        width: '100%',
        top: 0,
        zIndex: 1,
        flexGrow: 1,
        backgroundColor: theme.palette.background.default
      }}>
        <DealsHeader/>
        {<DealsFilter/>}
      </Box>
      <Grid container spacing={0} sx={{
        paddingTop: {xs: '165px', sm: '165px', md: '175px', lg: '122px'},
        paddingLeft: {xs: '10px', sm: '10px', md: '10px', lg: '0px'},
        flexGrow: 1,
        backgroundColor: theme.palette.background.default,
        height: '100%'
      }}>
        <Grid size={{xs: 1, sm: 1, md: 2.5, lg: 1.5}} sx={{backgroundColor: theme.palette.background.default}}/>
        <Grid size={9} sx={{minWidth: '980px', backgroundColor: theme.palette.background.default}}>
          <Grid sx={{height: 5}}></Grid>
          {<DealsList/>}
        </Grid>
        <Grid size={1.5} sx={{
          backgroundColor: theme.palette.background.default
        }}/>
      </Grid>
    </DealsProvider>)
}